import { render, staticRenderFns } from "./AlPagination.vue?vue&type=template&id=964352e4&scoped=true&"
import script from "./AlPagination.vue?vue&type=script&lang=js&"
export * from "./AlPagination.vue?vue&type=script&lang=js&"
import style0 from "./AlPagination.vue?vue&type=style&index=0&id=964352e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964352e4",
  null
  
)

export default component.exports